import {
  Button,
  Chip,
  Divider,
  Grid,
  IconButton,
  TextField,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { EventBusyOutlined, Search, Tune } from "@material-ui/icons";
import { ptBR } from "date-fns/locale";
import { memo } from "react";
import { DateRangePicker, END_DATE, START_DATE } from "react-nice-dates";
import "react-nice-dates/build/style.css";
import SwitchERP from "../../../../components/basics/Switch";
import Card from "../../../../components/cards/Card";
import { periods, reportTypes } from "../../constants";
import {
  accountingSystems,
  categorizedReleases,
} from "../ResultadoExercicioConstant";
import { useResultadoExercicioService } from "../contexts/ResultadoExercicioContext";
import "../styles/style.css";
import FinanceChip from "./FinanceChip";
import FinanceGroupDrawer from "./FinanceGroupDrawer";
import SelectFilter from "./SelectFilter";

const Filter = () => {
  const {
    cachedCompanies,
    financeCategoriesFilter,
    handleCheck,
    filters,
    setPeriod,
    setReportType,
    applyFinanceFilter,
    isGroupedByFinanceCategory,
    setSelectedCompany,
    setAccountingSystems,
    setCategorizedReleases,
    loadingCompanies,
    setDrawerOpen,
    setShowNotPayedAccounts,
    setShowNotReceivedTitles,
    filterPeriod,
    setCustomDatePeriod,
    refetch,
  } = useResultadoExercicioService();

  return (
    <Grid item xs>
      <Grid
        item
        container
        component={Card}
        direction={"column"}
        style={{
          gap: 24,
          borderLeft: "6px solid #d6e5ff",
          boxSizing: "border-box",
        }}
      >
        <FinanceGroupDrawer />
        <Grid item container xs style={{ gap: 16 }}>
          <Grid item xs>
            <SelectFilter
              filterMatch={filters.multicompany}
              filterOptions={cachedCompanies}
              setFilter={setSelectedCompany}
              label="Empresa"
              loading={loadingCompanies}
            />
          </Grid>
          <Grid item xs>
            <SelectFilter
              label="Tipo"
              filterMatch={filters.reportType}
              filterOptions={reportTypes}
              setFilter={setReportType}
            />
          </Grid>
          <Grid item xs>
            <SelectFilter
              label="Regime contábil"
              filterMatch={filters.accountingSystem}
              filterOptions={accountingSystems}
              setFilter={setAccountingSystems}
            />
          </Grid>
          <Grid item xs>
            <SelectFilter
              label="Lançamentos Categorizados"
              filterMatch={filters.categorizedRelease}
              filterOptions={categorizedReleases}
              setFilter={setCategorizedReleases}
            />
          </Grid>
        </Grid>
        <Grid item container xs style={{ gap: 8 }}>
          <Grid item xs={2}>
            <SelectFilter
              label="Periodo de busca"
              filterMatch={filters.period}
              filterOptions={periods}
              setFilter={setPeriod}
            />
          </Grid>
          {filters.period === "custom" && (
            <Grid item xs={4}>
              <DateRangePicker
                startDate={filterPeriod.startDate}
                endDate={filterPeriod.endDate}
                onStartDateChange={(newDate) => {
                  setCustomDatePeriod({
                    startDate: newDate,
                  });
                }}
                onEndDateChange={(newDate) => {
                  setCustomDatePeriod({
                    endDate: newDate,
                  });
                }}
                minimumLength={0}
                format="dd/MM/yyyy"
                weekdayFormat="EEEEE"
                locale={ptBR}
                maximumLength={365}
              >
                {({ startDateInputProps, endDateInputProps, focus }) => (
                  <div
                    className="date-range"
                    style={{
                      display: "flex",
                      gap: 16,
                    }}
                  >
                    <TextField
                      size="small"
                      label="Data inicial"
                      className={
                        "input" + (focus === START_DATE ? " -focused" : "")
                      }
                      {...startDateInputProps}
                      placeholder="Ex: 01/12/2022"
                    />
                    <TextField
                      size="small"
                      label="Data final"
                      className={
                        "input" + (focus === END_DATE ? " -focused" : "")
                      }
                      {...endDateInputProps}
                      placeholder="Ex: 31/12/2022"
                    />
                    <Tooltip title="Limpar filtro de datas">
                      <IconButton
                        size="small"
                        onClick={() =>
                          setCustomDatePeriod({
                            startDate: undefined,
                            endDate: undefined,
                          })
                        }
                        style={{
                          color: "red",
                        }}
                      >
                        <EventBusyOutlined />
                      </IconButton>
                    </Tooltip>
                  </div>
                )}
              </DateRangePicker>
            </Grid>
          )}
          <Grid item xs />
          <Grid
            item
            style={{
              alignItems: "center",
              display: "flex",
              marginRight: 16,
            }}
          >
            <SwitchERP
              label={`Exibir Contas não pagas`}
              labelPlacement="start"
              value={filters.showNotPayedAccounts}
              onChange={(event) =>
                setShowNotPayedAccounts(event.target.checked)
              }
            />
          </Grid>
          <Grid
            item
            style={{
              alignItems: "center",
              display: "flex",
              marginRight: 16,
            }}
          >
            <SwitchERP
              label={`Exibir Títulos não recebidos`}
              labelPlacement="start"
              value={filters.showNotReceivedTitles}
              onChange={(event) =>
                setShowNotReceivedTitles(event.target.checked)
              }
            />
          </Grid>
        </Grid>

        <Grid
          item
          xs
          style={{
            alignItems: "center",
            display: "flex",
            flexWrap: "wrap",
            gap: 8,
          }}
        >
          <Typography style={{ fontWeight: "bold" }} variant="subtitle2">
            Filtrando as categorias:{" "}
          </Typography>
          {financeCategoriesFilter.filtered.some((a) => a.checked) ? (
            financeCategoriesFilter.filtered.map((item) => {
              return <FinanceChip financeCategory={item} key={item.id} />;
            })
          ) : (
            <Typography>Exibindo todas as categorias</Typography>
          )}
        </Grid>
        {isGroupedByFinanceCategory && (
          <Grid
            item
            xs
            style={{
              alignItems: "center",
              display: "flex",
              gap: 8,
            }}
          >
            <Typography style={{ fontWeight: "bold" }} variant="subtitle2">
              Agrupando os Grupo de Categorias:
            </Typography>
            {financeCategoriesFilter.grouped.some((a) => a.checked) ? (
              financeCategoriesFilter.grouped.map(
                (item) =>
                  item.checked &&
                  !item.parentId && (
                    <Chip
                      item={item.id}
                      label={item.desc}
                      onDelete={() => {
                        const checkedCategories = handleCheck(item, false);
                        applyFinanceFilter(checkedCategories);
                      }}
                      color="primary"
                    />
                  )
              )
            ) : (
              <Typography>Sim</Typography>
            )}
          </Grid>
        )}

        <Divider />
        <Grid item xs container direction="row" spacing={2}>
          <Grid item xs>
            <Button
              size="small"
              color="primary"
              variant="contained"
              startIcon={<Search />}
              onClick={async () => {
                await refetch();
              }}
            >
              Gerar relatório
            </Button>
          </Grid>
          <Grid item>
            <Button
              startIcon={<Tune />}
              color="primary"
              variant="outlined"
              size="small"
              onClick={() => setDrawerOpen(true)}
            >
              Categorias do Financeiro
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default memo(Filter);
